/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * A counter bumped every time a new token is adopted, in any context.
 *
 * A request can be rejected with a token that has already been replaced by the
 * time the rejection arrives — a concurrent call hit the same 401 first and
 * renewed it. Comparing the generation read before the request with the one
 * after tells the two apart: if it moved, the rejection describes a token that
 * is no longer in use, so the right move is a plain replay, not a probe or a
 * second refresh.
 *
 * Kept outside {@link TokenManager} so interactor tests that replace the whole
 * TokenManager module still get a working counter.
 */
let mGeneration: number = 0;

/** The current generation. */
export function getTokenGeneration(): number {
  return mGeneration;
}

/** Called by TokenManager once a new token is in place. */
export function bumpTokenGeneration(): void {
  mGeneration = mGeneration + 1;
}
